import React from "react";
import { apiCallPost, formatAge, niceDateTime } from "../util/util";
import "../RxV2.css";
import {
  Button,
  ControlGroup,
  NonIdealState,
  Spinner,
} from "@blueprintjs/core";
import ClinicalVisitParametersPreview from "./RxV2Comp/ClinicalVisitParametersPreview";
import _ from "lodash";
import QRCode from "react-qr-code";
import { useParams } from "react-router-dom";
function withRouter(Component) {
  function ComponentWithRouter(props) {
    let params = useParams();
    return <Component {...props} params={params} />;
  }
  return ComponentWithRouter;
}

class ClinicalParamGlassAdvised extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
    };
  }
  render() {
    if (this.state.data.length > 0) {
      return (
        <div>
          Glass Advice:{" "}
          <b>
            {this.state.data[0].data[0].value}
            {": "}
            {(this.state.data[0].data[1].value || []).join(", ")}
          </b>
        </div>
      );
    }
    return [];
  }
}

class ClinicalParamFunctionalEyes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
    };
  }
  render() {
    if (this.state.data.length > 0) {
      return <div>Functional Eyes: {this.state.data[0].data[0].value}</div>;
    }
    return [];
  }
}

class ClinicalParamGlassIPD extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
    };
  }
  render() {
    if (this.state.data.length > 0) {
      return (
        <div>
          IPD: {this.state.data[0].data[0].value}{" "}
          {this.state.data[0].data[0].unit}
        </div>
      );
    }
    return [];
  }
}

class RxV2Low extends React.Component {
  state = {
    isLoading: true,
    isError: false,
  };
  componentDidMount() {
    this.getData();
  }
  getData = async () => {
    try {
      let res = await apiCallPost("/print/clinical2", {
        visitId: this.props.params.visitId,
      });
      const isNayonika = res.branchInfo.hospital_name.includes("Nayonika");
      let tenant = "generic";
      const renderOptions = {
        suppressEyeBankPh: false,
        suppressInsurancePh: false,
        ...res.branchInfo.rxRenderOptions,
      };
      if (isNayonika) {
        tenant = "nayonika";
        renderOptions.suppressEyeBankPh = true;
        renderOptions.suppressInsurancePh = true;
      }

      this.setState({ ...res, isLoading: false, tenant, renderOptions });
    } catch (err) {
      this.setState({
        isError: true,
        isLoading: false,
      });
      console.log(err);
    }
  };
  renderSectionTitle = (text) => {
    let sectionMaps = {
      VISION: "Spectacles Prescription",
      HISTORY: "Context of Visit",
      EXAMINATION: "Examination",
      PLAN: "Plan",
      FILES: "Investigations & Procedures",
    };
    return (
      <div
        style={{
          textTransform: "uppercase",
          borderLeft: "2px solid grey",
          borderBottom: "2px solid grey",
          letterSpacing: "1mm",
          paddingLeft: "5px",
          backgroundColor: "#E6E7E7",
          width: "fit-content",
          marginBottom: "20px",
          fontSize: "large",
        }}
      >
        <b>{sectionMaps[text]}</b>
      </div>
    );
  };

  renderVisitSummaryTopBar = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "100%",
          flexWrap: "wrap",
          borderBottom: "1px solid grey",
        }}
      >
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          <div
            style={{
              letterSpacing: "1mm",
              borderRight: "2px solid #000",
              fontSize: "medium",
              textAlign: "right",
              paddingLeft: "5px",
              paddingRight: "10px",
              display: "flex",
              alignItems: "center",
            }}
          >
            VISIT <br /> SUMMARY
          </div>
          <div
            style={{
              fontSize: "small",
            }}
          >
            <div
              style={{
                paddingLeft: "10px",
                textTransform: "uppercase",
              }}
            >
              <b>{this.state.patientInfo.name}</b>
            </div>{" "}
            <div
              style={{
                paddingLeft: "10px",
              }}
            >
              {this.state.patientInfo.sex} |{" "}
              {formatAge(this.state.patientInfo.dob)}
            </div>
            <div
              style={{
                marginLeft: "10px",
                paddingLeft: "2px",
                paddingRight: "2px",
                border: "1px solid black",
                width: "fit-content",
                backgroundColor: "#E6E7E7",
              }}
            >
              <b>{this.state.patientInfo.sysPid}</b>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            fontSize: "smaller",
            flexDirection: "column",
            textAlign: "right",
          }}
        >
          <div>{this.state.patientInfo.address}</div>
          <div>Phone: {this.state.patientInfo.phone}</div>
          <div>
            Rx Generated At:{" "}
            <b>
              {this.state.visitInfo.doneAt
                ? niceDateTime(this.state.visitInfo.doneAt)
                : niceDateTime(new Date())}
            </b>
          </div>
          <div className="pres-no__print">
            <ControlGroup>
              <Button
                icon="print"
                text="Print"
                onClick={() => {
                  window.print();
                }}
                fill
              />
            </ControlGroup>
          </div>
        </div>
      </div>
    );
  };
  renderBottomHospitalInfoBar = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          textAlign: "right",
          padding: "5px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <div>
            <img
              alt="Client Logo"
              src={this.state.branchInfo.logoUrl}
              height="70px"
              width="auto"
            />
          </div>
          <div
            style={{
              marginLeft: "10px",
              marginRight: "10px",
              textTransform: "uppercase",
              letterSpacing: "1mm",
              fontSize: "small",
              textAlign: "left",
              maxWidth: "125px",
            }}
          >
            {this.state.branchInfo.sesiNABH ? (
              <img
                src={this.state.branchInfo.sesiNABH}
                alt="NABH Certified"
                style={{
                  width: "100px",
                  height: "auto",
                }}
              />
            ) : (
              <div>{this.state.branchInfo.hospital_name}</div>
            )}
          </div>
          <div
            style={{
              fontSize: "smaller",
              textAlign: "left",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            {this.state.branchInfo.hospital_contact[0]}
            <br />
            {this.state.branchInfo.hospital_contact[1]}
            <br />
            {this.state.branchInfo.hospital_contact[2]}
            <br />
            {this.state.branchInfo.hospital_contact[3]}
            {this.state.branchInfo.sesiDELT
              ? [
                  <br />,
                  <b style={{ color: "red" }}>
                    {this.state.branchInfo.sesiDELT}
                  </b>,
                ]
              : null}
          </div>
        </div>
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <div
              style={{
                marginRight: "10px",
                fontSize: "smaller",
              }}
            >
              {this.state.branchInfo.ClinicPh ? (
                <>
                  Clinic: {this.state.branchInfo.ClinicPh}
                  <br />
                </>
              ) : null}
              {!this.state.renderOptions.suppressEyeBankPh &&
              this.state.branchInfo.EyeBankPh ? (
                <>
                  Eye Bank: {this.state.branchInfo.EyeBankPh}
                  <br />
                </>
              ) : null}
              {!this.state.renderOptions.suppressInsurancePh &&
              this.state.branchInfo.InsurancePh ? (
                <>
                  Insurance: {this.state.branchInfo.InsurancePh}
                  <br />
                </>
              ) : null}
              {this.state.branchInfo.email ? (
                <>
                  {this.state.branchInfo.email}
                  <br />
                </>
              ) : null}
              {this.state.branchInfo.website ? (
                <>
                  {this.state.branchInfo.website}
                  <br />
                </>
              ) : null}
            </div>
            <div>
              <QRCode
                size={70}
                value={`https://print.newchart.care/glass2/${this.props.params.visitId}`}
                level="H"
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  renderDoc = () => {
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          marginBottom: "10px",
          marginLeft: "10px",
          justifyContent: "flex-end",
          alignItems: "center",
          textAlign: "right",
          pageBreakInside: "avoid",
        }}
      >
        <div>
          <br /> <br />
          <hr />
          <div style={{ fontSize: "medium" }}>
            <b>{this.state.resource.name}</b>
          </div>
          <div>{this.state.resource.qualifications}</div>
          <div>Registration: {this.state.resource.mrNumber}</div>
        </div>
      </div>
    );
  };
  renderPageHeader = () => {
    return (
      <div className="rx2_page_header">{this.renderVisitSummaryTopBar()}</div>
    );
  };
  renderPageFooter = () => {
    return (
      <div className="rx2_page_footer">
        {this.renderBottomHospitalInfoBar()}
      </div>
    );
  };
  renderContentTable = () => {
    return (
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <td>
              <div className="rx2_page_header_space"></div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                {this.state.cparams.length > 0 ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      width: "100%",
                    }}
                  >
                    {this.renderSectionTitle("VISION")}
                  </div>
                ) : null}
                <div
                  style={{
                    width: "100%",
                  }}
                >
                  <ClinicalVisitParametersPreview
                    data={_.filter(
                      this.state.cparams,
                      (x) => x.parameterType === "VISION"
                    )}
                    renderOptions={{
                      ...this.state.renderOptions,
                      showFullAcuityTable: true, // always show full acuity table in Glass Rx
                    }}
                  />
                  <ClinicalParamFunctionalEyes
                    data={_.filter(
                      this.state.cparams,
                      (x) => x.parameterType === "FUNCTIONAL_EYES"
                    )}
                  />
                  <ClinicalParamGlassAdvised
                    data={_.filter(
                      this.state.cparams,
                      (x) => x.parameterType === "GLASS_RX"
                    )}
                  />
                  <ClinicalParamGlassIPD
                    data={_.filter(
                      this.state.cparams,
                      (x) => x.parameterType === "INTERPUPILLARY_DISTANCE"
                    )}
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                }}
              >
                {this.renderDoc()}
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              <div className="rx2_page_footer_space"></div>
            </td>
          </tr>
        </tfoot>
      </table>
    );
  };
  render() {
    if (this.state.isLoading) {
      return (
        <div
          style={{
            display: "flex",
            width: "100vw",
            height: "100vh",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <NonIdealState icon={<Spinner />} title="Loading..." />
        </div>
      );
    }
    if (this.state.isError) {
      return (
        <div
          style={{
            display: "flex",
            width: "100vw",
            height: "100vh",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <NonIdealState
            icon="warning-sign"
            title="We ran into an error. If you face this problem multiple times, please contact support."
          />
        </div>
      );
    }
    return (
      <div>
        <div style={{ padding: "3px" }}>
          <style type="text/css" media="print">
            {" @page { size: A5 landscape !important; margin: 5mm !important;"}
          </style>
          {this.renderPageHeader()}
          {this.renderPageFooter()}
          <div style={{ width: "98vw" }}>{this.renderContentTable()}</div>
        </div>
      </div>
    );
  }
}

const GlassRxV2 = withRouter(RxV2Low);
export default GlassRxV2;
